import { Injectable } from '@angular/core';

//cdk
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

//rxjs
import { Subject } from 'rxjs'
import { scan, map, distinctUntilChanged } from 'rxjs/operators'
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private spinnerTopRef: OverlayRef;

  private spin$: Subject<number> = new Subject()

  /**
   * Set the behaviour of the spinner
   */
  constructor(
    private overlay: Overlay,
  ) {

    this.spinnerTopRef = this.overlay.create({
      hasBackdrop: true,
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    });

    this.spin$
      .asObservable()
      .pipe(
        scan((acc, next) => {
          if (!next) return 0;
          return (acc + next) >= 0 ? acc + next : 0;
        }, 0),
        map(val => val > 0),
        distinctUntilChanged()
      )
      .subscribe(
        (res) => {
          if (res) {
            this.spinnerTopRef.attach(new ComponentPortal(SpinnerComponent))
          }
          else if (this.spinnerTopRef.hasAttached()) {
            this.spinnerTopRef.detach();
          }
        }
      )
  }

  /**
   * Show the spinner
   */
  show() {
    this.spin$.next(1);
  }

  /**
   * Hide the spinner
   */
  hide() {
    this.spin$.next(-1);
  }

  /**
   * Reset the spinner behaviour to default
   */
  reset() {
    this.spin$.next(0);
  }
}
